/**
 * Where the API is served: the app's own origin. In dev, the Vite server
 * proxies the API paths (see `VITE_DEV_API_URL` in vite.config.ts) so the
 * Sanctum session cookie stays same-site. Kept free of imports: the API
 * client loads it while the store/helper modules that import it are still
 * initialising.
 *
 * Request paths carry their own `api/` prefix (`api/work`, `api/note/3`).
 */
export const apiOrigin = window.location.origin

export const baseURL = `${apiOrigin}/`
